<div data-test-id="custom-input-container" class="tw-flex tw-flex-col">
  @if (label) {
    <label data-test-id="custom-input-label" class="tw-text-primary tw-font-medium tw-text-base tw-leading-[30px] tw-mb-2 tw-relative">
      {{label}}
      @if (required) {
        <span data-test-id="custom-input-required-indicator" class="tw-text-danger tw-ml-1">*</span>
      }
      @if (infoIconDescription) {
        <svg data-test-id="custom-input-info-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="tw-inline-block tw-peer tw-cursor-pointer tw-ml-2">
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 16V12" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 8H12.01" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div data-test-id="custom-input-info-tooltip" class="tw-absolute tw-bottom-[100%] tw-left-0 tw-right-0 tw-bg-[#D9EBF3] tw-rounded-[8px] tw-p-3 tw-flex tw-items-center tw-gap-3 tw-hidden peer-hover:tw-flex">
          <svg data-test-id="custom-input-info-tooltip-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 16V12" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 8H12.01" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p data-test-id="custom-input-info-tooltip-text" class="tw-m-0 tw-text-[#0077AD] tw-leading-[30px] tw-text-[12px] tw-flex-1 tw-cursor-pointer">{{infoIconDescription | transloco}}</p>
        </div>
      }
    </label>
  }
  <div data-test-id="custom-input-field-wrapper" class="tw-w-full tw-relative">
    <input
      data-test-id="custom-input-field"
      class="tw-h-[65px] tw-w-full tw-border tw-rounded-lg tw-px-[20px] tw-text-primary tw-outline-primary tw-placeholder-lightPlaceholder read-only:tw-bg-inputDisabledBg disabled:tw-bg-inputDisabledBg"
      [ngClass]="{
        'tw-pr-12': secure,
        '!tw-border-danger': (didBlur && hasError) || (!!value && hasError),
        '!tw-border-[2px]': (didBlur && hasError) || (!!value && hasError),
        'tw-border-lightBlueBorder': !((didBlur && hasError) || (!!value && hasError)),
      }"
      [placeholder]="placeholder"
      [type]="(secure && !disableSecurity) ? 'password' : type"
      [value]="value"
      (input)="onInput($event)"
      (focus)="inputFocus.next(); onTouched()"
      (blur)="inputBlur.next(); didBlur = true; onTouched()"
      (click)="inputClick.next($event)"
      [disabled]="disabled"
      [readOnly]="readOnly"
    />
    @if (iconUrl) {
      <img
        data-test-id="custom-input-trailing-icon"
        (click)="iconClick.next()"
        [src]="iconUrl"
        class="tw-absolute tw-top-5 tw-right-5 tw-w-6 tw-cursor-pointer"
      />
    }
    @if (secure) {
      <img
        data-test-id="custom-input-toggle-secure-icon"
        (click)="disableSecurity = !disableSecurity"
        src="/assets/images/eye.jpg"
        class="tw-absolute tw-top-5 tw-right-5 tw-w-6 tw-cursor-pointer"
      />
    }
    @if ((didBlur && ngControl?.control?.errors?.email) || (!!value && ngControl?.control?.errors?.email)) {
      <p data-test-id="custom-input-email-error" class="tw-mt-2 tw-text-danger">{{'yellowIndigoUI.invalidEmailFormat'|transloco}}</p>
    }
  </div>
</div>
